import { render, staticRenderFns } from "./ArticleShow.vue?vue&type=template&id=1862fed1&scoped=true&"
import script from "./ArticleShow.vue?vue&type=script&lang=ts&"
export * from "./ArticleShow.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleShow.vue?vue&type=style&index=0&id=1862fed1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1862fed1",
  null
  
)

export default component.exports